import { css } from '@emotion/core';
import { StyledColumnWrap, StyledColumnWrapper } from './styles';
export default (function (theme) {
  return /*#__PURE__*/css(StyledColumnWrap, "{&.el--3{grid-template-columns:1fr;@media screen and (min-width:40em) and (max-width:60em){grid-template-columns:1fr 1fr;", StyledColumnWrapper, "{&:nth-of-type(3){grid-column:1/span 2;}}}@media screen and (min-width:60em){grid-template-columns:1fr 1fr 1fr;}}");
});